import PUFFJ from '@amzn/katal-localization/dist/puffj/puffj';

const convertPuffToJson = (file: any): Record<string, any> => {
  const puffj = new PUFFJ({
    text: JSON.stringify(file),
  });

  const i18nextResourceFile: Record<string, any> = {};
  const stringIds = Object.keys(puffj.toObject().resources);

  for (const stringId of stringIds) {
    const value = puffj.get(stringId, {});
    i18nextResourceFile[stringId] = value;
  }

  return i18nextResourceFile;
};

export default convertPuffToJson;
